// Subscriptions pipelines
import {
	addUserAuthorizationSubscription,
	deleteUserAuthorizationSubscription,
	addUserAuthorizationLocationSubscription,
	deleteUserAuthorizationLocationSubscription,
	deleteUserGroupSubscription,
	groupAccessModificationsSubscription,
	updateUserProfilePictureSubscription,
} from "./queries";

const resolveUserSubscriptionPipeline = ({ localUser, location, tenant }) => [
	{
		context: "onAddUserAuthorization",
		query: addUserAuthorizationSubscription,
		variables: {
			_id: localUser._id,
		},
	},
	{
		context: "onDeleteUserAuthorization",
		query: deleteUserAuthorizationSubscription,
		variables: {
			_id: localUser._id,
		},
	},
	{
		context: "onAddUserAuthorizationLocation",
		query: addUserAuthorizationLocationSubscription,
		variables: {
			_id: localUser._id,
		},
	},
	{
		context: "onDeleteUserAuthorizationLocation",
		query: deleteUserAuthorizationLocationSubscription,
		variables: {
			_id: localUser._id,
		},
	},
	{
		context: "onDeleteUserGroup",
		query: deleteUserGroupSubscription,
		variables: {
			locationId: location?.locationId,
		},
	},
	{
		context: "onGroupAccessModifications",
		query: groupAccessModificationsSubscription,
		variables: {
			locationId: location?.locationId,
		},
	},
	{
		context: "onGlobalDeleteUserGroup",
		query: deleteUserGroupSubscription,
		variables: {
			locationId: tenant,
		},
	},
	{
		context: "onGlobalGroupAccessModifications",
		query: groupAccessModificationsSubscription,
		variables: {
			locationId: tenant,
		},
	},
	{
		context: "onUpdateUserProfilePicture",
		query: updateUserProfilePictureSubscription,
		variables: {
			_id: localUser._id,
		},
	},
];

export { resolveUserSubscriptionPipeline };
